import { pagesModule } from '@/store/database/pagesModule';
function stripHtml(html) {
  let tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
}

// function createNav(navs) {
//   const ul = document.createElement('ul');
//   for (name in navs) {
//     const nav = navs[name];
//     const a = document.createElement('a');
//     a.href = nav.url;
//     a.appendChild(document.createTextNode(nav.label));
//     const li = document.createElement('li');
//     li.id = 'nav-' + name;
//     li.appendChild(a);
//     if ('subnav' in nav) li.appendChild(createNav(nav.subnav));
//     ul.appendChild(li);
//   }
//   return ul;
// }

export const buildList = (rootId, resultType) => {
  //  What kind of result types
  //  String
  //  Unordered list (html style) (maybe not need that)
  //  bulleted list string
  //  Tabs
  //  HTML
  //  Markdown
  //  json
  //  we are also creating an html element
  const createListItem = ({ pageId, tabs = '' }) => {
    const pageModule = pagesModule.doc(pageId);
    if (pageModule.data == undefined) {
      console.log('no page', pageId);
      return false;
    }
    const page = pageModule.data;
    const htmlTitle = page.title;
    const textTitle = stripHtml(htmlTitle);
    let string = tabs + textTitle + '\n';
    //  We build an html bulleted list, first prepare the text, but keep internal html
    let innerHtml = htmlTitle.replace('</p>', '</br>').replace('<p>', '');
    const li = document.createElement('li');
    li.innerHTML = innerHtml;

    //  setup the object
    console.log(page);
    const object = {
      name: textTitle,
      htmlTitle,
      type: page.type,
      flair: page.flair,
      lastModified: page.updated_at
        ? page.updated_at.toDate()
        : page.createdOn.toDate
        ? page.createdOn.toDate()
        : page.createdOn
    };
    //  if have children create and append a UI
    const childrenNotes = Object.values(page.pageNotes)
      .filter(n => !n.toDelete && n.pageId !== undefined)
      .sort((a, b) => (a.order < b.order ? -1 : 1));
    if (childrenNotes.length) {
      const childUl = document.createElement('ul');
      object.children = [];
      childrenNotes.forEach(n => {
        const childData = createListItem({ pageId: n.pageId, tabs: tabs + '\t' });
        if (childData) {
          childUl.appendChild(childData.li);
          string = string + childData.string;
          object.children.push(childData.object);
        }
      });
      li.appendChild(childUl);
    }
    return { li, string, object };
  };

  // const ul = document.createElement('ul');
  const { li, object, string } = createListItem({ pageId: rootId });
  // ul.appendChild(li);
  return { li, object, string };

  // let noteIndex = myNoteArray.findIndex(o => o.id === newNoteId);

  // //here's the note from the corresponding Key
  // let currentNote = myNoteArray[noteIndex];

  // //Get all the pageNotes within the current NoteCard (sometimes they're notes, sometimes cards)
  // let childrenNoteArr = Object.values(currentNote.pageNotes).filter(n => !n.toDelete);
  // let trimmedTitle = currentNote.title.replace(/[\n\r]/g, '');

  // miniContext.title = trimmedTitle;
  // miniContext.children = [];
  // console.log(trimmedTitle); //print the current note's title

  // //sort the child notes based on position
  // childrenNoteArr.sort((a, b) => {
  //   return a.order - b.order;
  // });

  // //go through each child reference (called "pageNotes") and
  // //console.log("What's the array length of ChildrenNoteArr: " + childrenNoteArr.length);
  // for (let i = 0; i < childrenNoteArr.length; i++) {
  //   //get the pageId for the i'th child note
  //   switch (childrenNoteArr[i].type) {
  //     case 'card':
  //       let currPageNoteId = childrenNoteArr[i].pageId;
  //       let currChildNote = findNote(currPageNoteId, myNoteArray); //go the the noteArray master list and grab the note that matches the ID
  //       let childContext = {};
  //       miniContext.children.push(
  //         buildMiniContext(childContext, currChildNote.id, myNoteArray, boolOnlyPrintTitles)
  //       );
  //       break;
  //     case 'note':
  //       // if it's not a card, then print it if boolOnlyPrintTitles is false
  //       if (
  //         childrenNoteArr[i].content.html !== null &&
  //         childrenNoteArr[i].content.html.length > 0 &&
  //         !boolOnlyPrintTitles
  //       ) {
  //         console.log(childrenNoteArr[i].content.html);
  //         miniContext.children.push(childrenNoteArr[i].content.html);
  //       }
  //       break;
  //     case 'widget':
  //       if ((childrenNoteArr[i].widgetType = 'resource') && !boolOnlyPrintTitles) {
  //         let resourceId = childrenNoteArr[i].content.widgetData.resourceId;
  //         console.log('Found a resource with id: ' + resourceId);
  //       }
  //   }
  // }
  // return miniContext;
}

function buildMarkdownString(miniContext, markdownString, bulletLevel) {
  let strPrefix = '';
  switch (bulletLevel) {
    case 0:
      strPrefix = '# ';
      break;
    case 1:
      strPrefix = '## ';
      break;
    default:
      for (let i = 0; i < bulletLevel - 2; i++) {
        strPrefix = strPrefix + '\t';
      }
      strPrefix = strPrefix + '* ';
      break;
  }

  if (miniContext.title != '') {
    //I want to make sure the string isn't empty
    markdownString = markdownString + strPrefix + miniContext.title + '\r';
  }

  for (let i = 0; i < miniContext.children.length; i++) {
    if (typeof miniContext.children[i] === 'string') {
      //some of children are just strings, some are note objects
      if (stripHTML(miniContext.children[i]) != '') {
        markdownString = markdownString + '````' + stripHTML(miniContext.children[i]) + '````\r';
      }
    } else {
      // if they're note objects, then recursively build it
      markdownString = buildMarkdownString(
        miniContext.children[i],
        markdownString,
        bulletLevel + 1
      );
    }
  }

  return markdownString;
}

function stripHTML(textToStrip) {
  var div = document.createElement('div');
  div.innerHTML = textToStrip;
  return div.textContent || div.innerText || '';
}

function downloadJSON(miniContext, fileName) {
  let content = JSON.stringify(myContext);
  var a = document.createElement('a');
  let contentType = 'text/plain';
  var file = new Blob([content], { type: contentType });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
}
